import Vue from 'vue';
import VueScrollTo from 'vue-scrollto';
import App from './App.vue';
import router from './router';
import i18n from '@/i18n';
import store from './store';


Vue.config.productionTip = false;


Vue.use(VueScrollTo, {
  container: 'body',
  duration: 500,
  easing: 'ease',
  offset: -56,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true,
});


new Vue({
  i18n,
  router,
  store,
  render: h => h(App),
}).$mount('#app');
